import isEmpty from "lodash/isEmpty";
import type { RuleHandler } from "../types";

const checkMinimumExpectedResults: RuleHandler = (context, requirement) => {
  const requirementAttributes = requirement.userDrivenAttributes;

  if (typeof requirementAttributes.minimumExpectedResults !== "undefined") {
    if (isEmpty(context.selection?.expectedResults)) return false;

    // convert automation config to match the same shape as the
    // expectedResults from the event: { [resultType]: number }
    const automationRequirementConfig =
      requirementAttributes.minimumExpectedResults.reduce<
        Record<string, number>
      >((acc, expected) => {
        if (!acc[expected.resultType]) {
          acc[expected.resultType] = expected.minimum;
        }

        return acc;
      }, {});

    if (
      !Object.keys(context.selection.expectedResults).some((result) => {
        const minimum = automationRequirementConfig[result];
        return context.selection.expectedResults[result] >= minimum;
      })
    )
      return false;
  }

  return true;
};

export { checkMinimumExpectedResults };
